import { markActionComplete } from 'user-context/onboarding';
import { getIsCpqThemeEditorPath } from './urls';
import { CUSTOMIZE_QUOTE_THEME_STYLES } from '../constants/commerceTaskKeys';
import Raven from 'raven-js';
export const maybeMarkCommerceTaskComplete = ({
  taskKey,
  showTaskCompletionModal = true
}) => {
  if (taskKey === CUSTOMIZE_QUOTE_THEME_STYLES && !getIsCpqThemeEditorPath(window.location.pathname)) {
    return;
  }
  markActionComplete(taskKey, {
    showTaskCompletionModal
  }).catch(Raven.captureException.bind(Raven));
};

/**
 * Async version of maybeMarkCommerceTaskComplete that returns a promise.
 * Use this when you need to wait for the request to complete before performing
 * other actions (e.g., page redirects). The promise always resolves (never rejects)
 * and returns a boolean indicating whether the task was successfully marked complete.
 */
export const maybeMarkCommerceTaskCompleteAsync = ({
  taskKey,
  showTaskCompletionModal = true
}) => {
  if (taskKey === CUSTOMIZE_QUOTE_THEME_STYLES && !getIsCpqThemeEditorPath(window.location.pathname)) {
    return Promise.resolve(false);
  }
  return markActionComplete(taskKey, {
    showTaskCompletionModal
  }).then(() => true).catch(error => {
    Raven.captureException(error);
    return false;
  });
};